export default {"src":"/_next/static/media/check-your-email-icon.a7da3f27.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};